import { render } from "./Index.vue?vue&type=template&id=36666966&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=36666966&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36666966"

export default script